<template>
	<v-col class="d-flex child-flex elevation-0" cols="4">
		<v-hover>
			<template v-slot:default="{ hover }">
				<!--Here is where the post code for updating will go-->
				<v-card class="mx-auto pa-1">
					Posted {{ getTime(post.created_at) }}
					<v-btn color="grey darken-1" @click="overlay = !overlay" class="float-right" icon>
						<v-icon>mdi-dots-horizontal</v-icon>
					</v-btn>
					<v-card-text class="pa-0" v-if="post.files === null"></v-card-text>
					<v-img v-if="post.files" :aspect-ratio="12 / 6" width="450" :src="post.files">
						<v-card v-if="post.files.includes('mp4' || 'mp3')">
							<video width="350" controls>
								<source :src="post.files" />
							</video>
						</v-card>
					</v-img>
					<v-card-subtitle class="pb-0">
						<v-icon>mdi-map-marker</v-icon>
						{{ post.location }}
						<br />
						{{ createSubstr(post.content) }}...
					</v-card-subtitle>
					<v-card-text class="text--primary">
						<a :href="'' + post.link" target="_blank">{{ post.link }}</a>
						<br />
					</v-card-text>
					<v-overlay :value="overlay" absolute color="#000">
						<!--Edit Buttton-->
						<div class="text-center">
							<v-btn outlined elevation-2 color="white" @click="promptEditPost">Edit</v-btn> |
							<!--Delete Button-->
							<v-btn outlined elevation-2 color="white" @click="alertDialog = true">
								Delete
							</v-btn>
							<v-btn icon dark @click="overlay = false">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</div>
						<div class="editPostClass" v-show="editPost">
							<v-card outlined scrollable elevation-2 width="370">
								<v-container>
									<v-file-input small-chips label="Update Image" v-model="uploadFile"></v-file-input>
									<v-textarea v-model="content" scrollable clearable filled color="deep-purple"
										label="Update Content" rows="3"></v-textarea>
									<v-text-field type="text" v-model="uploadedLink" filled class="pb-3" height="20px"
										dense hide-details="auto" label="Add article link(if any)"></v-text-field>
									<v-autocomplete label="Update Country" class="pt-0" :items="countries" dense
										return-object item-text="name" v-model="uploadLocation"></v-autocomplete>
								</v-container>
								<v-card-actions>
									<v-btn @click="editPost = false" text>
										Cancel
									</v-btn>
									<v-spacer></v-spacer>
									<v-slide-x-reverse-transition>
										<v-tooltip v-if="formHasErrors" left>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon class="my-0" v-bind="attrs" @click="resetForm" v-on="on">
													<v-icon>mdi-refresh</v-icon>
												</v-btn>
											</template>
											<span>Refresh form</span>
										</v-tooltip>
									</v-slide-x-reverse-transition>
									<v-btn color="primary" text @click="handlePostUpdate">
										Update
									</v-btn>
								</v-card-actions>
							</v-card>
						</div>
						<div v-show="alertDialog" max-width="290" class="text-center pt-3">
							<v-sheet class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block" color="white" outlined
								elevation-2 dark>
								<div class="black--text text--lighten-1 text-body-2 mb-4">
									Are you sure you want to delete this post?
								</div>
								<v-btn :disabled="loading" class="ma-1" color="grey" plain @click="alertDialog = false">
									Cancel
								</v-btn>
								<v-btn :loading="loading" class="ma-1" color="error" plain @click="removePost">
									Delete
								</v-btn>
							</v-sheet>
						</div>
					</v-overlay>
				</v-card>
			</template>
		</v-hover>
	</v-col>
</template>



<script>
import countries from '../countries'
const moment = require('moment')
moment().format()

// import { mapGetters, mapState } from 'vuex'

export default {
	data: () => ({
		// For "My Projects feature"
		n: 1,
		alertDialog: false,
		dialog: false,
		overlay: false,
		loading: false,
		countries: [],
		uploadLocation: "",
		postEdit: false,
		showOverlay: false,
		uploadedLink: "",
		content: "",
		formHasErrors: false,
		uploadFile: null,
		editPost: false,
	}),
	props: {
		post: {
			type: Object,
			required: true, // if it's required
		},
	},
	methods: {
		getTime(publishedDate) {
			// Get todays date and the published date and find out how long
			// it's being since the article was posted.
			//
			//const m1 = new Date(); // prints: Toady's date
			console.log(publishedDate)
			const m2 = new Date(publishedDate) // prints: Date of article
			const timeFromNow = moment(m2).fromNow() // Returns date that article was created
			return timeFromNow
		},
		createSubstr(content) {
			console.log(content)
			if (content === undefined) {
				return ""
			}
			return content.substr(0, 180)
		},
		handlePostUpdate() {
			if (this.uploadFile || this.content || this.uploadLocation || this.uploadedLink) {
				const postData = {
					content: this.content,
					location: this.uploadLocation.name,
					link: this.uploadedLink,
					files: this.uploadFile
				}

				console.log('postData from profilePost', postData)

				const formData = new FormData();
				formData.append('location', this.uploadLocation.name);
				formData.append('content', this.content);
				formData.append('link', this.uploadedLink);
				if (this.uploadFile !== null) {
					formData.append('files', this.uploadFile);

				}

				this.$emit('update-post-event', this.post.id, formData);

				this.editPost = false

			}
		},
		promptEditPost() {
			console.log('Edit clicked')
			this.content = this.post.content
			this.uploadLocation = this.post.location
			// this.uploadFile = this.post.files
			this.uploadedLink = this.post.link
			this.editPost = true
		},
		//loading feature for delete button.
		removePost() {

			this.loading = true
			this.$emit('delete-post-event', this.post.id);
			setTimeout(() => {
				this.loading = false
				this.alertDialog = false

			}, 1500)

		},
	},
	mounted() {
		this.countries = countries
	},

	computed: {
		// Planner 
		//
		//this.$refs.calendar.checkChange(),
		// ...mapState(['user']),
		// ...mapGetters({ user: "auth/user" }),

		// Task computed methods
		//
		// completedTasks() {
		// 	return this.tasks.filter(task => task.done).length
		// },
		// progress() {
		// 	return this.completedTasks / this.tasks.length * 100
		// },
		// remainingTasks() {
		// 	return this.tasks.length - this.completedTasks
		// },

	}
}
</script>